import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { toDayJs, toThousandsForMates } from '@/filters';
function saveDataToObj(obj, child) {
  if (!obj["".concat(child.c21Header, "-").concat(child.name)]) {
    obj["".concat(child.c21Header, "-").concat(child.name)] = {
      header: child.header,
      name: child.name,
      data: [child]
    };
  } else {
    obj["".concat(child.c21Header, "-").concat(child.name)].data.push(child);
  }
}
function toPreviewData(html) {
  var tableDatas = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var sysParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var data = JSON.parse(JSON.stringify(html));
  var reg = /\{\{([^}]+)\}\}/g; // 匹配{{}}
  if (reg.test(data)) {
    var paramList = tableDatas;
    var importData = {};
    var sameTableData = {};
    var importParamList = [];
    paramList.forEach(function (child) {
      if (child.type === '导入') {
        saveDataToObj(importData, child);
        importParamList.push(child);
      } else if (child.type === '表格') {
        saveDataToObj(sameTableData, child);
      }
    });
    paramList = paramList.filter(function (item) {
      return item.type !== '导入';
    });
    data = data.replace(reg, function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      if (args && args[1]) {
        if (args[1] === '函证对象名称' && sysParams.cusName) {
          return sysParams.cusName;
        } else if (args[1] === '回函地址' && sysParams.returnAddress) {
          return sysParams.returnAddress;
        } else if (args[1] === '函证联系人号码' && sysParams._returnStaffPhone) {
          return sysParams._returnStaffPhone;
        } else if (args[1] === '回函传真' && sysParams.returnFax) {
          return sysParams.returnFax;
        } else if (args[1] === '联系人邮箱' && sysParams.returnMail) {
          return sysParams.returnMail;
        } else if (args[1] === '会计师事务所名称' && sysParams.officeName) {
          return sysParams.officeName;
        } else if (args[1] === '函证编号' && sysParams.confirmCode) {
          return sysParams.confirmCode;
        } else if (args[1] === '回函快递手机号' && sysParams.returnMobile) {
          return sysParams.returnMobile;
        } else if (args[1] === '函证所属公司名称' && sysParams.c02AuditCompany) {
          return sysParams.c02AuditCompany;
        } else if (args[1] === '审计日期区间' && sysParams.startDate && sysParams.endDate) {
          return "".concat(sysParams.startDate, "\u81F3").concat(sysParams.endDate);
        } else if (args[1] === '函证联系人' && sysParams._returnStaff) {
          return sysParams._returnStaff;
        } else if (args[1] === '审计截止日期年' && sysParams._endDate) {
          return "".concat(toDayJs(sysParams._endDate).year());
        } else if (args[1] === '审计截止日期月' && sysParams._endDate) {
          var month = toDayJs(sysParams._endDate).month() + 1;
          return "".concat(month >= 10 ? month : "0".concat(month));
        } else if (args[1] === '审计截止日期日' && sysParams._endDate) {
          var d = toDayJs(sysParams._endDate).date();
          return "".concat(d >= 10 ? d : "0".concat(d));
        } else if (args[1] === '审计开始日期年' && sysParams._startDate) {
          return "".concat(toDayJs(sysParams._startDate).year());
        } else if (args[1] === '审计开始日期月' && sysParams._startDate) {
          // const month = toDayJs(sysParams._startDate).month() + 1
          // return `${month >= 10 ? month : `0${month}`}`
          return "01";
        } else if (args[1] === '审计开始日期日' && sysParams._startDate) {
          // const d = toDayJs(sysParams._startDate).date()
          // return `${d >= 10 ? d : `0${d}`}`
          return "01";
        } else {
          var importRes = importParamList.find(function (child) {
            return child.name === args[1];
          });
          if (importRes) {
            return transformDataToTableData(importData, args[1]);
          }
          var res = paramList.find(function (child) {
            return child.name === args[1];
          });
          if (args[1] === '银行扣款账号') {
            var _res = paramList.find(function (child) {
              return child.name === '银行存款';
            });
            if (_res && (_res.c21Type === '表格' || _res.c21Type === '导入') && _res.data) {
              var _d = _res.data.split('|');
              if (_d.length && _d.length >= 2) {
                return _d[1];
              }
            }
          }
          if (res) {
            if (res.type === '表格') {
              if (sameTableData["".concat(res.c21Header, "-").concat(res.name)] && sameTableData["".concat(res.c21Header, "-").concat(res.name)].data && sameTableData["".concat(res.c21Header, "-").concat(res.name)].data.length > 1) {
                return transformDataToTableData(sameTableData, args[1]);
              } else {
                return buildTableData(res.header, res.data, res.params);
              }
            } else if (res.type === '文本') {
              return res.data;
            }
          }
          return '';
          // return args[0];
        }
      }
      return '';
    });
  }
  return data;
}
function transformDataToTableData(obj, name) {
  for (var key in obj) {
    var needHeader = true;
    if (obj.hasOwnProperty(key)) {
      if (obj[key].name === name) {
        var data = obj[key].data;
        var d = data.map(function (child) {
          return child.data;
        });
        var params = void 0;
        if (d && d.length) {
          params = data[0].params;
        }
        // 如果导入类型只有1条数据, 默认为文本模式
        if (d && d.length && data[0].header) {
          var header = data[0].header.split('|').filter(function (item) {
            return item;
          });
          if (header.length === 1) {
            needHeader = false;
          }
        }
        // 表格模式
        return buildTableData(obj[key].header, d, params, needHeader);
      }
    }
  }
  return '';
}
function checkData(number, title) {
  // isFinite
  if (title.indexOf('金额') !== -1 || title.indexOf('余额') !== -1) {
    return isFinite(number);
  }
  return false;
}
function buildTableData(headers, datas, params) {
  var needHeader = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var header = headers;
  var data = datas;
  var param = params;
  var widths;
  if (param) {
    widths = param.split(':');
    widths.shift();
    widths = widths.join('').split('/');
  }
  if (header) {
    var headerList = header.split('|');
    header = headerList;
    data = data ? JSON.parse(JSON.stringify(data)) : '';
    header = header.map(function (key, index) {
      return "<td class=\"ck-editor__editable ck-editor__nested-editable print-table-th\" width=\"".concat(widths ? widths[index] : '', "\">").concat(key, "</td>");
    });
    var str = '';
    if (!Array.isArray(data)) {
      data = data.split('|');
      data = data.map(function (item, index) {
        // 判断是否为金额, 如果是金额就转为会计格式
        return "<td class=\"ck-editor__editable ck-editor__nested-editable  print-table-td\">".concat(checkData(item, headerList[index]) ? toThousandsForMates(item) : item, "</td>");
      });
      var tds = [data];
      tds.push(header.map(function (head) {
        return "<td class=\"ck-editor__editable ck-editor__nested-editable  print-table-td\"></td>";
      }));
      var trs = tds.map(function (td) {
        return "<tr>".concat(td.join(''), "</tr>");
      });
      // trs.push(
      //   `<tr>${header.map(()=> '<td class="ck-editor__editable ck-editor__nested-editable  print-table-td"></td>').join('')}</tr>`
      // );
      str = "<table class=\"print-table-content\">\n                 <tr>".concat(header.join(''), "</tr>\n                  ").concat(trs.join(''), "\n              </table>");
    } else {
      data = data.map(function (item) {
        var tds = item.split('|');
        return "<tr>\n                      ".concat(tds.map(function (sub, index) {
          return "<td class=\"ck-editor__editable ck-editor__nested-editable  print-table-td\">".concat(checkData(sub, headerList[index]) ? toThousandsForMates(sub) : sub, "</td>");
        }).join(''), "\n                  </tr>");
      });
      // data.push(
      //   `<tr>${header.map(()=> '<td class="ck-editor__editable ck-editor__nested-editable  print-table-td"></td>').join('')}</tr>`
      // )
      str = "<table class=\"print-table-content\">\n                ".concat(needHeader ? "<tr>".concat(header.join(''), "</tr>") : '', "\n                ").concat(data.join(''), "\n              </table>");
    }
    return "<figure class=\"table ck-widget ck-widget_with-selection-handle print-table\">".concat(str, "</figure>");
  }
  return '';
}
export default toPreviewData;